import { showNotification } from '../../../app/common/helpers/notifications';
var displayErrorMessageInterceptor = function (info) {
    var _a, _b;
    var shouldDisplayError = !!((_a = info.meta) === null || _a === void 0 ? void 0 : _a.displayErrors) && !!((_b = info.meta) === null || _b === void 0 ? void 0 : _b.getErrorMessage);
    if (!shouldDisplayError) {
        return;
    }
    var message = info.meta.getErrorMessage(info.error, info.data);
    if (message) {
        showNotification({
            title: message.title || 'ERROR',
            message: message.message,
            children: message.errors,
            autoDismiss: 8,
        });
    }
};
export var initDisplayErrorMessageInterceptor = function () {
    window.addEventListener('squire-http-request-error', function (event) {
        displayErrorMessageInterceptor(event.detail);
    });
};
